import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, LinearProgress } from '@material-ui/core';
import { ArrowForwardIos } from '@material-ui/icons';
import './Test.css';
import { useDispatch, useSelector } from 'react-redux';
import UserNav from '../../components/UserNav';
import config from '../../config';

function TestM() {
	const history = useHistory();
	const dispatch = useDispatch();
	const selectedTest = useSelector(state => state.testSelected);
	const user = useSelector(state => state.auth.user);
	const [beginTest, setBeginTest] = useState(false);
	const [testQuestions, setTestQuestions] = useState([]);
	const [currentQuestion, setCurrentQuestion] = useState(1);
	const [answers, setAnswers] = useState([]);
	const [progress, setProgress] = useState(0);
	const [answerSelected, setAnswerSelected] = useState(false);
	const [testResult, setTestResult] = useState(null);
	const [attempts, setAttempts] = useState([]);

	useEffect(() => {
		if (!selectedTest || !selectedTest.title) {
			const stored = localStorage.getItem('selectedTest');
			if (stored) {
				const parsed = JSON.parse(stored);
				dispatch({ type: 'SET_SELECTED_TEST', payload: parsed.title });
			} else {
				history.replace('/usertests');
			}
		}
	}, [selectedTest, dispatch, history]);

	useEffect(() => {
		if (user && user.email) {
			fetch(`${config.API_BASE}/results/${user.email}`)
				.then(res => res.json())
				.then(data => setAttempts(data));
		}
	}, [user]);

	useEffect(() => {
		if (beginTest) {
			const getTestData = async () => {
				try {
					const response = await fetch(`${config.API_BASE}/questions?type=Media%20Test`);
					const questions = await response.json();
					setTestQuestions(questions);
					console.log('Fetched media questions:', questions);
				} catch (error) {
					console.error('Error fetching questions:', error);
					setTestQuestions([]);
				}
			};
			getTestData();
		}
	}, [beginTest]);

	const getAttemptCount = () => {
		return attempts.filter(a => 
			a.testType === 'Media Test' || 
			a.testType === 'media'
		).length;
	};

	const getButtonText = () => {
		const count = getAttemptCount();
		if (count === 0) return 'TAKE TEST';
		return 'RE-TAKE TEST';
	};

	const getMediaResults = () => {
		let answerArr = [ ...answers ];
		let textualArr = answerArr.slice(0, 3);
		let auditoryArr = answerArr.slice(3, 6);
		let visualArr = answerArr.slice(6);

		let answerObj = {
			textual: 0,
			auditory: 0,
			visual: 0
		};

		textualArr.forEach((el) => {
			if (el === 'yes') answerObj['textual']++;
		});
		auditoryArr.forEach((el) => {
			if (el === 'yes') answerObj['auditory']++;
		});
		visualArr.forEach((el) => {
			if (el === 'yes') answerObj['visual']++;
		});

		const res = Object.keys(answerObj).reduce((a, b) => (answerObj[a] > answerObj[b] ? a : b));
		return res;
	};

	const handleNextQuestion = () => {
		if (currentQuestion === testQuestions.length) {
			let res = getMediaResults();
			setTestResult(res);
			setBeginTest(false);
			insertResult('media', res);
			return;
		} else {
			if (answerSelected) {
				setCurrentQuestion(currentQuestion + 1);
				setProgress(((currentQuestion + 1) / testQuestions.length) * 100);
				setAnswerSelected(false);
			} else {
				alert('Please select either yes or no');
			}
		}
	};

	const yesClicked = () => {
		setAnswerSelected(true);
		let arr = [ ...answers ];
		arr[currentQuestion - 1] = 'yes';
		setAnswers(arr);
	};

	const noClicked = () => {
		setAnswerSelected(true);
		let arr = [ ...answers ];
		arr[currentQuestion - 1] = 'no';
		setAnswers(arr);
	};

	const insertResult = async (insertkey, insertvalue) => {
		const currentAnswers = [...answers];
		try {
			await fetch(`${config.API_BASE}/results`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					email: user.email,
					key: insertkey,
					value: insertvalue,
					answers: currentAnswers
				})
			});
		} catch (error) {
			console.error('Error submitting result:', error);
		}
	};

	if (!selectedTest || selectedTest.title !== 'Media Test') {
		return <div className="test__container">No test selected.</div>;
	}

	return (
		<div className="test__container" style={{ position: 'relative', minHeight: '100vh', background: '#f5f8ff', paddingTop: 64 }}>
			<UserNav />
			{!beginTest && !testResult ? (
				<div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
					<h2 style={{ fontSize: 32, fontWeight: 700, marginBottom: 32 }}>{selectedTest.title}</h2>
					<Button onClick={() => setBeginTest(true)} variant="contained" color="primary" size="large" style={{ fontSize: 20, padding: '16px 48px' }}>
						{getButtonText()}
					</Button>
				</div>
			) : beginTest && testQuestions.length > 0 && !testResult ? (
				<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
					<LinearProgress variant="determinate" value={progress} style={{ width: '100%', maxWidth: 500, marginBottom: 24 }} />
					<div style={{ width: '100%', maxWidth: 500 }}>
						<div style={{ marginBottom: 24, background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', padding: 16 }}>
							<h3>Question {currentQuestion} of {testQuestions.length}</h3>
							<p>{testQuestions[currentQuestion - 1]?.question}</p>
							<div style={{ display: 'flex', gap: 16, marginTop: 8 }}>
								<Button
									variant={answers[currentQuestion - 1] === 'yes' ? 'contained' : 'outlined'}
									color="primary"
									onClick={yesClicked}
								>
									Yes
								</Button>
								<Button
									variant={answers[currentQuestion - 1] === 'no' ? 'contained' : 'outlined'}
									color="secondary"
									onClick={noClicked}
								>
									No
								</Button>
							</div>
						</div>
					</div>
					<div style={{ display: 'flex', gap: 16, marginTop: 32 }}>
						<Button onClick={() => setCurrentQuestion(currentQuestion - 1)} disabled={currentQuestion === 1} variant="outlined">Previous</Button>
						<Button onClick={handleNextQuestion} variant="contained" color="primary" endIcon={<ArrowForwardIos />}>
							{currentQuestion === testQuestions.length ? 'Finish' : 'Next'}
						</Button>
					</div>
				</div>
			) : (
				<div className="test__complete" style={{ textAlign: 'center', marginTop: 80 }}>
					<h2>Test complete!</h2>
					{testResult && (
						<strong>Your media preference is: {testResult.charAt(0).toUpperCase() + testResult.slice(1)}</strong>
					)}
				</div>
			)}
		</div>
	);
}

export default TestM; 